<template>
  <div class="tasks">
    <div v-for="task of sortedTasks" :key="task.id" class="task">
      <span>{{ task.label }}</span>
      <q-toggle :disable="task.disable" :value="task.value" @input="toggle(task.id)" />
    </div>
  </div>
</template>

<script>
import { cloneDeep, orderBy } from 'lodash'

export default {
  props: {
    tasks: Array,
    hasDependencies: Boolean
  },

  computed: {
    sortedTasks() {
      return orderBy(this.tasks, 'milestone.order')
    }
  },

  methods: {
    toggle(taskId) {
      const tasks = cloneDeep(this.tasks)
      const taskIndex = tasks.findIndex(task => task.id === taskId)
      if (~taskIndex) {
        if (this.hasDependencies) {
          this.toggleWithDependencies(tasks, taskIndex, tasks[taskIndex], !tasks[taskIndex].value)
        } else {
          tasks[taskIndex].value = !tasks[taskIndex].value
          this.$emit('updated', tasks)
        }
      }
    },

    toggleWithDependencies(tasks, index, task, value) {
      {
        task.value = value
        if (task.name === 'approve_invoices_applicable' && !value) {
          this.toggleDependency(tasks, 'vendor_payments_applicable', false)
        } else if (task.name === 'vendor_payments_applicable' && value) {
          this.toggleDependency(tasks, 'approve_invoices_applicable', true)
        }
        tasks.splice(index, 1, task)
        this.$emit('updated', tasks)
      }
    },

    toggleDependency(tasks, depName, newVal) {
      const index = tasks.findIndex(task => task.name === depName)
      tasks[index].value = newVal
    }
  }
}
</script>

<style lang="stylus" scoped>
.tasks {
  padding 20px
  display grid
  grid-auto-flow column
  align-items end
  gap 20px
}
</style>
